export function activities(state) {
	return state.activities
}

export function activities_menu(state) {
	return state.activities_menu
}

export function hierarchy_order(state) {
	return state.hierarchy_order
}

export function id(state) {
	return state.id
}

export function loading(state) {
	return state.loading
}

export function block_activities_menu(state) {
	return state.block_activities_menu
}
